import React, { Component } from "react";

import styles from "./connectionDataItem.module.scss";
import getDates from "../../shared/services/date.service";

class ConnectionDataItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen,
      data: JSON.parse(JSON.stringify(props.data)),
    };
  }

  onColapserClick() {
    const { isOpen } = this.state;

    this.setState({ isOpen: !isOpen });
  }

  render() {
    const { isOpen, data } = this.state;
    const { isViewPoints } = this.props;

    return (
      <div>
        <div className={styles.connectionDataItemColapser} onClick={this.onColapserClick.bind(this)}>
          <div>{getDates.getDateFormat10(data.package.timeStamp)}</div>
        </div>

        {!isOpen ? null : (
          <div className={styles.connectionDataItemContainer}>
            <div className={styles.connetionInfo}>
              <div>Количество сообщений: </div> <div>{data.package.count};</div>
              <div>Размер: </div> <div>{data.package.size} байт;</div>
              <div>CRC: </div> <div>{data.package.asciicrc};</div>
            </div>

            <div className={styles.preparedPointsContainer}>
              {data.preparedPoints.map((x, index) => {
                return (
                  <div className={styles.connetionInfo} key={x.id + " " + index}>
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "30px" }}>{index + 1}.</div>
                        <div style={{ width: "200px" }}>
                          [<span>Время сервера: </span> {getDates.getDateFormat10(x.timeStamp)}]
                        </div>
                        <div style={{ width: "170px" }}>
                          <span style={{ color: "white" }}>{"TI"}</span>={x.data["TI"]};
                        </div>
                      </div>

                      <div style={{ display: "flex", width: "75%", flexWrap: "wrap" }}>
                        {Object.keys(x.data).map((key) => {
                          if (key === "TI") return null;

                          return (
                            <div key={key}>
                              <span style={{ color: "white" }}>{key}</span>={x.data[key]}
                              {"; "}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {!isViewPoints ? null : (
              <div>
                {data.points.map((x, index) => {
                  if (x === null) {
                    return (
                      <div className={styles.connetionInfo} key={index} style={{ color: "#9bbaff" }}>
                        <div style={{ width: "30px" }}>{index + 1}.</div>
                        {" - - - "}
                      </div>
                    );
                  }

                  return (
                    <div className={styles.connetionInfo} style={{ marginBottom: "10px", color: "#9bbaff" }}>
                      <div key={x.id} style={{ width: "100%", display: "flex" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "30px" }}>{index + 1}.</div>
                          <div style={{ width: "200px" }}>
                            [<span>Время сервера: </span> {getDates.getDateFormat10(x.timeStamp)}]
                          </div>
                          <div style={{ width: "170px" }}>
                            <span style={{ color: "white" }}>{"TI"}</span>={x.data["TI"]};
                          </div>
                        </div>

                        <div style={{ display: "flex", width: "75%", flexWrap: "wrap" }}>
                          {Object.keys(x.data).map((key) => {
                            if (key === "TI") return null;

                            return (
                              <div key={key}>
                                <span key={key} style={{ color: "white" }}>
                                  {key}
                                </span>
                                ={x.data[key]};
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div style={{ display: "flex" }}></div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ConnectionDataItem;
